export interface IGreenChoicesState {
    isShowModal: boolean;
}

export const initialGreenChoices: IGreenChoicesState = {
    isShowModal: false,
};
